import React, { useState } from 'react';
import PageTitle from '../../../widgets/PageTitle/PageTitle';
import './YDCFinalist.scss';
import { Card, CardImg } from 'reactstrap';
import PreviewImageAndClick from '../../../widgets/PreviewImageAndClick/PreviewImageAndClick';

const YDCFinalist = (props) => {
  const { curLang, finalist, title, finalist_detail } = props;

  const [previewImgOpen, setPreviewImgOpen] = useState(false);
  const [selectImgIndex, setSelectImgIndex] = useState(0);
  const previewImgToggle = () => setPreviewImgOpen(!previewImgOpen);
  const selectImgIndexFun = (index) => setSelectImgIndex(index);

  const imageList = finalist.map((item, index) => ({
    image: item.finalist_images_upload,
  }));

  return (
    <>
      <PageTitle title={title} />
      <div className="ydc-finalist">
        <div className="finalist-card-grid">
          {imageList.map((item, index) => {
            return (
              // {imageList.length - 2 === index  && <Card key={`${index}_copy`} className="finalist-card"></Card>}
              item.image ? (
                <Card
                  key={index}
                  className="finalist-card"
                  onClick={() => {
                    selectImgIndexFun(index);
                    setPreviewImgOpen(true);
                  }}
                >
                  <div className="card-container">
                    <CardImg src={item.image} alt={`finalist-image-${index}`} />
                    {finalist_detail?.[index]?.finalist_name && (
                      <div className="itemCaption">{finalist_detail[index].finalist_name}</div>
                    )}
                  </div>
                </Card>
              ) : null
            );
          })}
        </div>
      </div>
      <PreviewImageAndClick
        previewImgToggle={previewImgToggle}
        previewImgOpen={previewImgOpen}
        selectImgIndex={selectImgIndex}
        selectImgIndexFun={selectImgIndexFun}
        imageList={imageList}
      />
    </>
  );
};

export default YDCFinalist;
